var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tk-button',_vm.disabled?'tk-disabled':'','button-'+_vm.type],on:{"click":_vm.a}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }